/* tslint:disable */
/* eslint-disable */
/**
 * NoRadio Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Archived } from './Archived';
import { ArchivedFromJSON, ArchivedFromJSONTyped, ArchivedToJSON } from './Archived';
import type { Deleted } from './Deleted';
import { DeletedFromJSON, DeletedFromJSONTyped, DeletedToJSON } from './Deleted';
import type { FileUrl } from './FileUrl';
import { FileUrlFromJSON, FileUrlFromJSONTyped, FileUrlToJSON } from './FileUrl';
import type { UpdatedAt } from './UpdatedAt';
import { UpdatedAtFromJSON, UpdatedAtFromJSONTyped, UpdatedAtToJSON } from './UpdatedAt';
import type { UpdatedBy } from './UpdatedBy';
import { UpdatedByFromJSON, UpdatedByFromJSONTyped, UpdatedByToJSON } from './UpdatedBy';

/**
 *
 * @export
 * @interface ShowAdminModel
 */
export interface ShowAdminModel {
    /**
     *
     * @type {string}
     * @memberof ShowAdminModel
     */
    id: string;
    /**
     *
     * @type {string}
     * @memberof ShowAdminModel
     */
    title: string;
    /**
     *
     * @type {string}
     * @memberof ShowAdminModel
     */
    type: string;
    /**
     *
     * @type {string}
     * @memberof ShowAdminModel
     */
    createdBy: string;
    /**
     *
     * @type {Date}
     * @memberof ShowAdminModel
     */
    createdAt: Date;
    /**
     *
     * @type {UpdatedBy}
     * @memberof ShowAdminModel
     */
    updatedBy?: UpdatedBy;
    /**
     *
     * @type {UpdatedAt}
     * @memberof ShowAdminModel
     */
    updatedAt?: UpdatedAt;
    /**
     *
     * @type {Archived}
     * @memberof ShowAdminModel
     */
    archived?: Archived;
    /**
     *
     * @type {Deleted}
     * @memberof ShowAdminModel
     */
    deleted?: Deleted;
    /**
     *
     * @type {FileUrl}
     * @memberof ShowAdminModel
     */
    fileUrl?: FileUrl;
}

/**
 * Check if a given object implements the ShowAdminModel interface.
 */
export function instanceOfShowAdminModel(value: object): boolean {
    if (!('id' in value)) return false;
    if (!('title' in value)) return false;
    if (!('type' in value)) return false;
    if (!('createdBy' in value)) return false;
    if (!('createdAt' in value)) return false;
    return true;
}

export function ShowAdminModelFromJSON(json: any): ShowAdminModel {
    return ShowAdminModelFromJSONTyped(json, false);
}

export function ShowAdminModelFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): ShowAdminModel {
    if (json == null) {
        return json;
    }
    return {
        id: json['id'],
        title: json['title'],
        type: json['type'],
        createdBy: json['created_by'],
        createdAt: new Date(json['created_at']),
        updatedBy: json['updated_by'] == null ? undefined : UpdatedByFromJSON(json['updated_by']),
        updatedAt: json['updated_at'] == null ? undefined : UpdatedAtFromJSON(json['updated_at']),
        archived: json['archived'] == null ? undefined : ArchivedFromJSON(json['archived']),
        deleted: json['deleted'] == null ? undefined : DeletedFromJSON(json['deleted']),
        fileUrl: json['file_url'] == null ? undefined : FileUrlFromJSON(json['file_url']),
    };
}

export function ShowAdminModelToJSON(value?: ShowAdminModel | null): any {
    if (value == null) {
        return value;
    }
    return {
        id: value['id'],
        title: value['title'],
        type: value['type'],
        created_by: value['createdBy'],
        created_at: value['createdAt'].toISOString(),
        updated_by: UpdatedByToJSON(value['updatedBy']),
        updated_at: UpdatedAtToJSON(value['updatedAt']),
        archived: ArchivedToJSON(value['archived']),
        deleted: DeletedToJSON(value['deleted']),
        file_url: FileUrlToJSON(value['fileUrl']),
    };
}
